export const isTouchDevice = () => {
  try {
    document.createEvent('TouchEvent')
    return true
  } catch (e) {
    return false
  }
}

const getScreenWidth = () =>
  (window.innerWidth > 0) ? window.innerWidth : window.screen.width

export const isDesktop = () =>
  getScreenWidth() >= 1024

export const isTablet = () =>
  getScreenWidth() >= 768 && getScreenWidth() < 1024

export const isMobile = () =>
  getScreenWidth() < 768



// WEBPACK FOOTER //
// ./src/lib/responsive.js